import { render, staticRenderFns } from "./array_editor.vue?vue&type=template&id=38ba3706"
import script from "./array_editor.vue?vue&type=script&lang=js"
export * from "./array_editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports